import { FormDataConsumer, ReferenceArrayInput, required } from "react-admin";

import { AutocompleteInput } from "../../component/input";
import React from "react";
import { get } from "lodash";
import { useManyFormatter, useManyParser } from "ra-friendsofbabba";

const optionText = (record) =>
  `${get(record, "code")} - ${get(record, "name")}`;

const ScientificDisciplinarySectorsInput = (props) => {
  const manyFormatter = useManyFormatter();
  const manyParse = useManyParser();
  return (
    <FormDataConsumer {...props}>
      {({ formData }) => {
        const roles = get(formData, "roles", []);
        if (!roles.find((role) => role.id === 7)) {
          return null;
        }
        return (
          <ReferenceArrayInput
            {...props}
            validate={required()}
            parse={manyParse}
            format={manyFormatter}
            perPage={1000}
            reference="scientific-disciplinary-sectors"
            multiple
            optionText={optionText}
          >
            <AutocompleteInput multiple optionText={optionText} />
          </ReferenceArrayInput>
        );
      }}
    </FormDataConsumer>
  );
};
export default ScientificDisciplinarySectorsInput;
